export default "__VITE_ASSET__CXPXQskL__"